import React, { ReactNode } from 'react';
import { User } from '../../../interfaces/backend/User';
import { CodeType } from '../CodeType';
import { BuildCodeParams } from './CodeSample';
import Paragraph from 'antd/lib/typography/Paragraph';
import CodeBlock from '../CodeBlock';
import { BackendCodeSample, UserObjectStringMap } from './BackendCodeSample';

export default class BackendPhpSample extends BackendCodeSample {
  name = 'PHP';
  language = 'php';
  codeType = CodeType.BACKEND;
  tabIcon = '';
  commentChar = '//';

  buildCode({
    environment,
    notification,
    user,
    mergeTags
  }: BuildCodeParams): ReactNode {
    const composerInstall =
      'composer require notificationapi/notificationapi-php-server-sdk';

    const code = `use NotificationAPI\\NotificationAPI;

$notificationapi = new NotificationAPI(
  '${environment.clientId}', ${this.commentChar} clientId
  '${environment.clientSecret}' ${this.commentChar} clientSecret
);

$notificationapi->send([
  "notificationId" => "${notification.notificationId}",
  "user" => [
    ${this.buildUserObjectString(user, '\n    ')}
  ],
  "mergeTags" => ${
    JSON.stringify(mergeTags, null, 4)
      .replace(/\{/g, '[')
      .replace(/\}/g, ']')
      .replace(/:/g, ' =>')
      .slice(0, -1) + '  ]'
  }
]);`;

    return (
      <>
        <Paragraph style={{ paddingTop: 10 }}>
          To use the PHP NotificationAPI SDK, you must install it with Composer:
        </Paragraph>
        <CodeBlock language="bash" code={composerInstall} />
        <Paragraph>
          Once the NotificationAPI SDK is installed you can use the following
          code to send your first notification:
        </Paragraph>
        <CodeBlock language={this.language} code={code} />
      </>
    );
  }

  buildUserObject(user: User): UserObjectStringMap {
    return {
      id: `"id" => "${user.id}"`,
      email: `"email" => "${user.email}"`,
      number: {
        value: `"number" => "${user.number}"`,
        comment: 'Replace with your phone number'
      }
    };
  }
}
